'use client';

import { c as _c } from "react/compiler-runtime";
import { CmsValidityComponent } from '@spa/top-level-components/cms-page/metadata/CmsValidityComponent';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { ReactElement } from 'react';
import classNames from 'clsx';
import { format } from 'date-fns';
import styles from './magnolia-cms-validity.component.module.scss';
import { useCurrentTime } from '@spa/lib/react/hooks/useCurrentTime';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
const MagnoliaCmsValidityComponent: CmsValidityComponent = t0 => {
  const $ = _c(15);
  const {
    dateTo,
    dateFrom
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("cms-validity");
  const actualDate = useCurrentTime().getTime();
  let element;
  if (dateTo || dateFrom) {
    const isOutdatedComponent = dateTo !== null && actualDate > dateTo;
    const isActiveComponent = dateTo !== null && dateFrom !== null && actualDate > dateFrom && actualDate < dateTo || dateFrom !== null && dateTo == null && actualDate > dateFrom || dateTo !== null && dateFrom == null && actualDate < dateTo;
    const isFuture = dateFrom !== null && actualDate < dateFrom;
    let t1;
    if ($[0] !== isActiveComponent || $[1] !== isFuture || $[2] !== isOutdatedComponent) {
      t1 = classNames(styles["magnolia-validity__identifier"], {
        [styles["magnolia-validity__identifier--outdated"]]: isOutdatedComponent,
        [styles["magnolia-validity__identifier--active"]]: isActiveComponent,
        [styles["magnolia-validity__identifier--future"]]: isFuture
      });
      $[0] = isActiveComponent;
      $[1] = isFuture;
      $[2] = isOutdatedComponent;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    const identifierClassNames = t1;
    let t2;
    if ($[4] !== formatMessage) {
      t2 = date => {
        const formatedDate = format(new Date(date), "dd.MM.yyyy");
        return `${formatMessage("validFrom")}: ${formatedDate} `;
      };
      $[4] = formatMessage;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    const formatedDateFrom = t2;
    let t3;
    if ($[6] !== formatMessage) {
      t3 = date_0 => {
        const formatedDate_0 = format(new Date(date_0), "dd.MM.yyyy");
        return `${formatMessage("validTo")}: ${formatedDate_0}`;
      };
      $[6] = formatMessage;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    const formatedDateTo = t3;
    let t4;
    if ($[8] !== identifierClassNames) {
      t4 = <span className={identifierClassNames} />;
      $[8] = identifierClassNames;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    const t5 = dateFrom !== null && formatedDateFrom(dateFrom);
    const t6 = dateTo !== null && formatedDateTo(dateTo);
    let t7;
    if ($[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
      t7 = <span className={styles["magnolia-validity"]}>{t4}{t5}{t6}</span>;
      $[10] = t4;
      $[11] = t5;
      $[12] = t6;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    element = t7;
  } else {
    let t1;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <></>;
      $[14] = t1;
    } else {
      t1 = $[14];
    }
    element = t1;
  }
  return element;
};
export default MagnoliaCmsValidityComponent;